import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { User } from '../../../shared/models/user';
import { AccountService } from '../../../core/services/account.service';
import { showAlertDialog } from '../../../shared/helpers/showAlertDialog';
import { AlertType } from '../../../shared/models/alertType';
import { VoltarIndicatorComponent } from '../../../shared/components/voltar-indicator/voltar-indicator.component';
import { UsersService } from '../../../core/services/users.service';
import { Router } from '@angular/router';
import { BRANDING } from '../../../core/constants/branding.constants';

@Component({
  selector: 'app-alterar-senha',
  imports: [MatIconModule, MatDialogModule, CommonModule, ReactiveFormsModule, VoltarIndicatorComponent],
  templateUrl: './alterar-senha.component.html',
  styleUrl: './alterar-senha.component.scss'
})
export class AlterarSenhaComponent {
  branding = BRANDING;
  alterarSenhaForm: FormGroup;
  passwordVisible: boolean = false;
  newpasswordVisible: boolean = false;
  confirmationPasswordVisible: boolean = false;
  novaSenhaFocused: boolean = false;
  confirmeSenhaFocused: boolean = false;
  senhaAtualFocused: boolean = false;
  user: User;

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private usersService: UsersService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.user = usersService.currentUser()!;

    this.alterarSenhaForm = this.fb.group({
      senhaAtual: [''],
      novaSenha: ['', {
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).+$')
        ],
      }],
      confirmeSenha: ['', {
        validators: [Validators.required],
      }]
    }, { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(form: FormGroup) {
    const novaSenha = form.get('novaSenha');
    const confirmeSenha = form.get('confirmeSenha');
    if (novaSenha?.value !== confirmeSenha?.value) {
      confirmeSenha?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      confirmeSenha?.setErrors(null);
      return null;
    }
  }

  navigateBack() {
    this.accountService.logout();
  }

  onSubmit() {
    if (this.alterarSenhaForm.valid) {
      this.accountService.changePassword(this.alterarSenhaForm.value.senhaAtual, this.alterarSenhaForm.value.novaSenha)
        .subscribe(res => {
          const dialogRef = showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'A sua senha foi alterada com sucesso!');
          this.usersService.getUserInfo().subscribe(() => {
            this.router.navigate(['dash']);
          });
        });
    }
  }
}
